import AsyncStorage from '@react-native-async-storage/async-storage';

export class AsyncStorageAdapter {
  private static readonly USER_KEY = 'user';
  private static readonly TOKEN_KEY = 'token';
  private static readonly REFRESH_TOKEN_KEY = 'refresh_token';

  async saveUser(user: any): Promise<void> {
    if (!user) {
      throw new Error('User object is required');
    }
    
    const userKey = AsyncStorageAdapter.USER_KEY;
    const tokenKey = AsyncStorageAdapter.TOKEN_KEY;
    
    if (!userKey || !tokenKey) {
      throw new Error('Storage keys are not properly initialized');
    }
    
    await AsyncStorage.setItem(userKey, JSON.stringify(user));
    
    // Solo guardar el token si existe y es un string
    if (user.token && typeof user.token === 'string') {
      await AsyncStorage.setItem(tokenKey, user.token);
    }
    
    // Guardar refresh_token si existe
    if (user.refresh_token && typeof user.refresh_token === 'string') {
      await AsyncStorage.setItem(
        AsyncStorageAdapter.REFRESH_TOKEN_KEY,
        user.refresh_token,
      );
    }
  }

  async getUser(): Promise<any | null> {
    const userKey = AsyncStorageAdapter.USER_KEY;
    if (!userKey) {
      return null;
    }
    const userString = await AsyncStorage.getItem(userKey);
    return userString ? JSON.parse(userString) : null;
  }

  async getToken(): Promise<string | null> {
    const tokenKey = AsyncStorageAdapter.TOKEN_KEY;
    if (!tokenKey) {
      return null;
    }
    return await AsyncStorage.getItem(tokenKey);
  }

  async removeUser(): Promise<void> {
    const userKey = AsyncStorageAdapter.USER_KEY;
    const tokenKey = AsyncStorageAdapter.TOKEN_KEY;
    const refreshTokenKey = AsyncStorageAdapter.REFRESH_TOKEN_KEY;
    
    if (userKey) {
      await AsyncStorage.removeItem(userKey);
    }
    if (tokenKey) {
      await AsyncStorage.removeItem(tokenKey);
    }
    if (refreshTokenKey) {
      await AsyncStorage.removeItem(refreshTokenKey);
    }
  }

  async clear(): Promise<void> {
    await AsyncStorage.clear();
  }
}

